import React, { useState, useEffect } from 'react';
import {
  Tabs,
  Card,
  Row,
  Col,
  Button,
  Form,
  Select,
  DatePicker,
  Modal,
  message,
} from 'antd';
import Input from '../../../../ui/Input';
import TextArea from '../../../../ui/TextArea';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
import PageContainer from '../../../../CSIComponents/PageContainer';
import { getOTACodes } from '../../../../../services/common';
import {
  deletePolicyFees,
  updatePolicyFees,
} from './../../../../../services/policy';
import Loading from './../../../../Loading';

interface propsTypes {
  feesDetails: any;
  isEditable: void | any;
  cancelEditable: void | any;
  supplier: string;
  propertyId: string;
  changeTab: void | any;
  getPoliciesData: any;
  setPoliciesData: void | any;
  setFeesDetails: void | any;
}

const AMOUNT = 'Amount';
const FormItem = Form.Item;
const Option = Select.Option;
const { RangePicker } = DatePicker;
const TabPane = Tabs.TabPane;
const dateFormat = 'MM/DD/YYYY';
const FeesEdit = (props: propsTypes) => {
  const [typeOptions, setTypeOptions] = useState<any>([]);
  const [currentOptions, setCurrentOptions] = useState<any>([]);
  const [chargeFrequencyOptions, setChargeFrequencyOptions] = useState<any>([]);
  const [chargeUnitOptions, setChargeUnitOptions] = useState<any>([]);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [disableFlag, setDisableFlag] = useState(false);
  const [form] = Form.useForm();

  const getTypeOptions = async () => {
    const res = await getOTACodes('FTT', '');
    if (res.result.success) {
      setTypeOptions(res.otacodes);
    } else {
      setTypeOptions([]);
    }
  };
  const getCurrentOptions = async () => {
    const res = await getOTACodes('CUR', '');
    if (res.result.success) {
      setCurrentOptions(res.otacodes);
    } else {
      setCurrentOptions([]);
    }
  };
  const getChargeFrequenc = async () => {
    const res = await getOTACodes('CHG', 'ChargeFrequency');
    if (res.result.success) {
      setChargeFrequencyOptions(res.otacodes);
    } else {
      setChargeFrequencyOptions([]);
    }
  };

  const getChargeUnit = async () => {
    const res = await getOTACodes('CHG', 'ChargeUnit');
    if (res.result.success) {
      setChargeUnitOptions(res.otacodes);
    } else {
      setChargeUnitOptions([]);
    }
  };

  const [chargeType, setChargeType] = useState<any>(
    props?.feesDetails?.chargetype
  );
  useEffect(
    () => {
      getTypeOptions();
      getCurrentOptions();
      getChargeFrequenc();
      getChargeUnit();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const ModalHead = () => {
    return (
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          height: '50px',
          lineHeight: '50px',
          textIndent: '10px',
          borderBottom: '1px solid #ccc',
          color: '#fff',
          background: '#06789D',
          fontSize: 18,
          width: '100%',
        }}
      >
        Confirm
      </div>
    );
  };

  const updateFees = () => {
    form.validateFields().then((values) => {
      setLoadingFlag(true);
      const requestBody = {
        supplier: props.supplier,
        propertyId: props.propertyId,
        property: {
          policies: {
            feepolicy: [
              {
                feeid: values.feeid,
                feelangid: values.feelangid,
                policycode: values.policycode,
                startdate: values.dateRange
                  ? values.dateRange[0]
                    ? values.dateRange[0].format(dateFormat)
                    : null
                  : null,
                enddate: values.dateRange
                  ? values.dateRange[1]
                    ? values.dateRange[1].format(dateFormat)
                    : null
                  : null,
                application: values.application,
                type: values.type,
                chargetype: values.chargetype,
                chargeamount: values.chargeamount,
                //chargepercent: values.chargepercent,
                currency: values.currency,
                chargefrequency: values.chargefrequency,
                chargeunit: values.chargeunit,
                mandatory: values.mandatory === 'true',
                taxable:
                  values.taxable === 'true'
                    ? true
                    : values.taxable === 'false'
                    ? false
                    : null,
                description: values.description,
              },
            ],
          },
        },
      };
      updatePolicyFees(requestBody).then(
        (res) => {
          if (res.result.success) {
            setLoadingFlag(false);
            props.cancelEditable();
            values.startdate =
              values.dateRange && values.dateRange[0]
                ? values.dateRange[0].format(dateFormat)
                : '';
            values.enddate =
              values.dateRange && values.dateRange[1]
                ? values.dateRange[1].format(dateFormat)
                : '';
            props.setFeesDetails(values);
            // props.setPoliciesData({})
            props.getPoliciesData('FeesDetails');
          } else {
            setLoadingFlag(false);
            message.error({
              content: res?.error[0]?.message || 'operation failed',
            });
          }
        },
        (err) => {
          message.error({
            content: err?.message || err?.error[0]?.message,
          });
          setLoadingFlag(false);
          props.cancelEditable();
          // props.setPoliciesData({})
          // props.getPoliciesData('FeesDetails')
        }
      );
    });
  };

  const deleteFees = () => {
    const deleteTitle = props.feesDetails?.policycode;
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete ${deleteTitle} ?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      onOk() {
        setLoadingFlag(true);
        const requestBody = {
          supplier: props.supplier,
          propertyId: props.propertyId,
          property: {
            policies: {
              feepolicy: [
                {
                  feeid: form.getFieldValue('feeid'),
                  feelangid: form.getFieldValue('feelangid'),
                },
              ],
            },
          },
        };

        deletePolicyFees(requestBody).then(
          (res) => {
            setLoadingFlag(false);
            if (res.result.success) {
              props.cancelEditable();
              props.setPoliciesData({});
              props.getPoliciesData('Fees');
            } else {
              message.error({
                content: res?.error[0]?.message || 'operation failed',
              });
            }
          },
          (err) => {
            setLoadingFlag(false);
            props.cancelEditable();
            // props.setPoliciesData({})
            // props.getPoliciesData('Fees')
            message.error({
              content: err?.message || err?.error[0]?.message,
            });
          }
        );
      },
      onCancel() {
        setLoadingFlag(false);
      },
    });
  };

  const validateForm = () => {
    form
      .validateFields()
      .then(() => {
        setDisableFlag(false);
      })
      .catch((err) => {
        err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false);
      });
  };

  useEffect(
    validateForm,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <>
      <Tabs defaultActiveKey="detail">
        <TabPane
          tab="Detail"
          key="detail"
        >
          <PageContainer>
            <Card
              style={{ marginTop: -15 }}
              title={props.feesDetails?.policycode}
            >
              <div style={{ padding: '0 20px' }}>
                <Form
                  form={form}
                  layout="vertical"
                  onValuesChange={validateForm}
                  initialValues={{
                    ...props.feesDetails,
                  }}
                >
                  <FormItem
                    name="feeid"
                    style={{ display: 'none' }}
                  >
                    <Input />
                  </FormItem>
                  <FormItem
                    name="feelangid"
                    style={{ display: 'none' }}
                  >
                    <Input />
                  </FormItem>
                  <Row gutter={24}>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="policycode"
                        label="Policy Code"
                        rules={[
                          {
                            max: 64,
                            message:
                              'You have reached the max character length of 64',
                          },
                        ]}
                      >
                        <Input maxLength={64} />
                      </FormItem>
                    </Col>
                    <Col
                      span={12}
                      className="col-margin"
                    >
                      <FormItem
                        name="dateRange"
                        label="Start Date ~ End Date"
                      >
                        <RangePicker format={dateFormat} />
                      </FormItem>
                    </Col>
                    <Col span={5}></Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="application"
                        label="Application"
                      >
                        <Select allowClear showSearch>
                          <Option value="Inclusive">Inclusive </Option>
                          <Option value="Exclusive">Exclusive</Option>
                          <Option value="Cumulative">Cumulative </Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="type"
                        label="Type"
                        rules={[
                          {
                            required: true,
                            message: 'This field is required',
                          },
                        ]}
                      >
                        <Select allowClear showSearch>
                          {typeOptions.map((item: any) => (
                            <Option
                              value={item.codeName}
                              key={item.codeValue}
                            >
                              {item.codeName}
                            </Option>
                          ))}
                        </Select>
                      </FormItem>
                    </Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="chargetype"
                        label="Charge Type"
                        rules={[
                          {
                            required: true,
                            message: 'This field is required',
                          },
                        ]}
                      >
                        <Select allowClear showSearch
                          onChange={(value) => setChargeType(value)}
                        >
                          <Option value="Amount">Amount</Option>
                          <Option value="Percent">Percent</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span={5}></Col>
                    <>
                      {chargeType === AMOUNT ? (
                        <>
                          <Col
                            span={6}
                            className="col-margin"
                          >
                            <FormItem
                              name="chargeamount"
                              label="Charge(Amount)"
                              rules={[
                                {
                                  required: true,
                                  message: 'This field is required',
                                },
                                {
                                  pattern: /^\d*(\.\d*)?$/,
                                  message: 'This field should be a number.',
                                },
                              ]}
                            >
                              <Input />
                            </FormItem>
                          </Col>
                          <Col
                            span={6}
                            className="col-margin"
                          >
                            <FormItem
                              name="currency"
                              label="Currency"
                              rules={[
                                {
                                  required: true,
                                  message: 'This field is required',
                                },
                              ]}
                            >
                              <Select allowClear showSearch>
                                {currentOptions.map((item: any) => (
                                  <Option
                                    value={item.codeName}
                                    key={item.codeValue}
                                  >
                                    {item.codeName}
                                  </Option>
                                ))}
                              </Select>
                            </FormItem>
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col
                            span={6}
                            className="col-margin"
                          >
                            <FormItem
                              name="chargeamount"
                              label="Charge(Percent)"
                              rules={[
                                {
                                  required: true,
                                  message: 'This field is required',
                                },
                                {
                                  pattern: /^\d*(\.\d*)?$/,
                                  message: 'This field should be a number.',
                                },
                              ]}
                            >
                              <Input />
                            </FormItem>
                          </Col>
                        </>
                      )}
                    </>
                    {/* { chargeType === AMOUNT&&<Col span={5}></Col> } */}
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="chargefrequency"
                        label="Charge Frequency"
                        rules={[
                          {
                            required: true,
                            message: 'This field is required',
                          },
                        ]}
                      >
                        <Select allowClear showSearch>
                          {chargeFrequencyOptions.map((item: any) => (
                            <Option
                              value={item.codeName}
                              key={item.codeValue}
                            >
                              {item.codeName}
                            </Option>
                          ))}
                        </Select>
                      </FormItem>
                    </Col>
                    {chargeType === AMOUNT && <Col span={5}></Col>}
                    <Col span={6}>
                      <FormItem
                        name="chargeunit"
                        label="Charge Unit"
                        rules={[
                          {
                            required: true,
                            message: 'This field is required',
                          },
                        ]}
                      >
                        <Select allowClear showSearch>
                          {chargeUnitOptions.map((item: any) => (
                            <Option
                              value={item.codeName}
                              key={item.codeValue}
                            >
                              {item.codeName}
                            </Option>
                          ))}
                        </Select>
                      </FormItem>
                    </Col>
                    {chargeType !== AMOUNT && <Col span={5}></Col>}
                    <Col span={6}>
                      <FormItem
                        name="mandatory"
                        label="Mandatory"
                        rules={[
                          {
                            required: true,
                            message: 'This field is required',
                          },
                        ]}
                      >
                        <Select allowClear showSearch>
                          <Option value="true">Yes</Option>
                          <Option value="false">No</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col
                      span={6}
                      className="col-margin"
                    >
                      <FormItem
                        name="taxable"
                        label="Taxable"
                      >
                        <Select allowClear showSearch>
                          <Option value="true">Yes</Option>
                          <Option value="false">No</Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col
                      span={24}
                      className="col-margin"
                    >
                      <FormItem
                        name="description"
                        label="Description"
                        rules={[
                          {
                            max: 300,
                            message:
                              'You have reached the max character length of 300',
                          },
                        ]}
                      >
                        <TextArea
                          maxLength={300}
                          rows={3}
                          style={{ resize: 'none' }}
                        />
                      </FormItem>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Card>
          </PageContainer>
        </TabPane>
      </Tabs>
      <ActionButtonsBar
        onDelete={deleteFees}
        onCancel={() => {
          props.cancelEditable();
          props.changeTab('Fees');
        }}
        onSave={updateFees}
        disabledSave={disableFlag}
      />
      {loadingFlag && (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
          }}
        >
          <Loading type="large" />
        </div>
      )}
    </>
  );
};

export default FeesEdit;
